"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Multiply = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _react.default.createElement("path", {
  d: "M7 7l.1.001a7.01 7.01 0 00-1.602 2.402 2.999 2.999 0 000 5.195c.364.91.913 1.726 1.602 2.4L7 17A5 5 0 017 7zm5 0l.1.001a7.01 7.01 0 00-1.602 2.402 2.999 2.999 0 000 5.195c.364.91.913 1.726 1.602 2.4L12 17a5 5 0 010-10zm5 0a5 5 0 110 10 5 5 0 010-10zm0 2a3 3 0 100 6 3 3 0 000-6z",
  className: "fill",
  fillRule: "nonzero"
}));

var _default = Multiply;
exports.default = _default;